export const kpiData = [
  { id: 1, label: 'System Load', value: '78%', trend: '+2.4%', status: 'normal', icon: 'Activity' },
  { id: 2, label: 'Active Incidents', value: '3', trend: '-1', status: 'warning', icon: 'AlertTriangle' },
  { id: 3, label: 'Task Throughput', value: '1.2k/s', trend: '+14%', status: 'good', icon: 'Zap' },
  { id: 4, label: 'SLA Compliance', value: '99.9%', trend: 'Stable', status: 'good', icon: 'Shield' },
];

export const timelineEvents = [
  { id: 1, time: '10:42 AM', title: 'DB Replication Lag Detected', type: 'alert', description: 'Node-beta-4 showing 4s lag.' },
  { id: 2, time: '10:30 AM', title: 'Auto-Scaling Triggered', type: 'system', description: 'Provisioned 3 new worker nodes in us-east.' },
  { id: 3, time: '09:15 AM', title: 'Deploy: v4.2.0-rc', type: 'info', description: 'Pipeline completed successfully.' },
  { id: 4, time: '08:00 AM', title: 'Daily Backup Verified', type: 'success', description: 'All volumes backed up to cold storage.' },
];

export const playbooks = [
  { id: 1, name: 'Restart Worker Nodes', description: 'Gracefully drains and restarts stalled workers.', risk: 'Low', time: '~2m', icon: 'RefreshCw' },
  { id: 2, name: 'Flush Redis Cache', description: 'Clears all non-persistent cache keys.', risk: 'Medium', time: '~5s', icon: 'Database' },
  { id: 3, name: 'Failover Database', description: 'Promotes read-replica to primary. CAUTION.', risk: 'High', time: '~45s', icon: 'Server' },
  { id: 4, name: 'Scale Up Ingress', description: 'Increases load balancer capacity handles.', risk: 'Low', time: '~1m', icon: 'Maximize2' },
];